import { gql } from '@apollo/client';

export const GET_DRIVER_ACCOUNTS_FOR_LOCATION_TRACK = gql`
  query GetDriverAccountsForLocationTrack($name: String, $phone: String) {
    getDriverAccountsForLocationTrack(name: $name, phone: $phone) {
      id
      name
      phone
    }
  }
`;

export interface DriverAccountForLocationTrack {
  id: string;
  name: string;
  phone: string | null;
}

export interface GetDriverAccountsForLocationTrackResponse {
  getDriverAccountsForLocationTrack: DriverAccountForLocationTrack[];
}

